import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../../config/constants';
import {
	COLOR_DRAWER_ICON_PATTERN_LIBRARY,
	COLOR_DRAWER_ITEM_HOVER,
	COLOR_DRAWER_ITEM_TEXT,
} from '../../../styles/tokens';

export const PatternLibraryLink = ({ callBack }) => {
	const navigate = useNavigate();
	const location = useLocation();

	if (
		location.pathname.toLowerCase() === ROUTES.PATTERN_LIBRARY.toLowerCase()
	)
		return null;

	const handleClick = () => {
		callBack();
		navigate(ROUTES.PATTERN_LIBRARY);
	};

	return (
		<ListItem key={'PatternLibrary'} disablePadding>
			<ListItemButton
				onClick={handleClick}
				sx={{ '&:hover': { backgroundColor: COLOR_DRAWER_ITEM_HOVER } }}
			>
				<ListItemIcon
					sx={{
						color: COLOR_DRAWER_ICON_PATTERN_LIBRARY,
						minWidth: '40px',
					}}
				>
					<AutoStoriesIcon />
				</ListItemIcon>
				<ListItemText
					primary={'Pattern Library'}
					primaryTypographyProps={{
						variant: 'h5',
						sx: { color: COLOR_DRAWER_ITEM_TEXT },
					}}
				/>
			</ListItemButton>
		</ListItem>
	);
};
